import api from "@/services/axios";

export function bootIntercom(user = null) {
  const INTERCOM_APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;
  
  window.intercomSettings = {
    app_id: INTERCOM_APP_ID,
    ...(user
      ? {
          user_id: user.id,
          name: user.name,
          email: user.email,
          created_at: Math.floor(new Date(user.createdAt).getTime() / 1000),
          intercom_user_jwt: "", // Will be set asynchronously below
        }
      : {}),
  };

  if (!window.Intercom) {
    (function () {
      const w = window;
      const ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        const d = document;
        const i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        const l = function () {
          const s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/" + INTERCOM_APP_ID;
          const x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };

        if (user) {
          api
            .get("/user/intercom")
            .then((response) => {
              if (response.data?.token) {
                window.intercomSettings.intercom_user_jwt = response.data.token;
              }
              l();
            })
            .catch((error) => {
              console.error("Failed to fetch Intercom token:", error);
              l();
            });
        }
      }
    })();
  } else {
    window.Intercom("update", window.intercomSettings);
  }
}

export function shutdownIntercom() {
  if (window.Intercom) {
    window.Intercom("shutdown");
  }
}
